<template>
	<div class="rbox">
		<div class="leftdiv">
			<el-carousel height="calc(100vh)">
				<el-carousel-item v-for="(v,k) in appdata.list.ad_register_list" :key="k">
					<img class="img" :src="v.pic">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="rightdiv">
			<div class="tabs">
				<div class="checked">会员注册</div>
			</div>
			<div class="formdiv">
				<el-form ref="registerFormRef" :model="registerForm" :rules="registerRules" class="register-form"
					@submit.prevent="handleRegister">

					<el-form-item prop="username">
						<el-input v-model="registerForm.username" placeholder="请输入登录名" size="mini"
							class="custom-input" />
					</el-form-item>

					<el-form-item prop="password">
						<el-input v-model="registerForm.password" type="password" placeholder="请输入密码" size="mini"
							class="custom-input" show-password autocomplete="new-password"/>
					</el-form-item>

					<el-form-item prop="confirmPassword">
						<el-input v-model="registerForm.confirmPassword" type="password" placeholder="确认密码" size="mini"
							class="custom-input" show-password autocomplete="new-password"/>
					</el-form-item>

					<el-form-item prop="realName">
						<el-input v-model="registerForm.realName" placeholder="真实姓名" size="mini"
							class="custom-input" />
					</el-form-item>

					<el-form-item prop="contact" class="qq">
						<el-input v-model="registerForm.contact" placeholder="在线qq" size="mini" class="custom-input" />
						<div class="note">
							<span class="note-text">(注:请使用本QQ号加1571441975为好友,否则无法通过审核!)</span>
						</div>
					</el-form-item>
					
					<el-form-item prop="email">
						<el-input v-model="registerForm.email" placeholder="邮箱" size="mini" class="custom-input" />
					</el-form-item>

					<el-form-item prop="phone">
						<div class="phone-input-group">
							<el-input v-model="registerForm.phone" placeholder="联系电话" size="mini"
								class="custom-input phone-input" />
						</div>
					</el-form-item>

					<el-form-item prop="verifyCode">
						<el-input v-model="registerForm.verifyCode" placeholder="请输入验证码" size="mini"
							class="custom-input" />
						<span class="verify-btn" @click="handleGetVerifyCode">
							{{ verifyCodeText }}
						</span>
					</el-form-item>

					<el-form-item prop="referralCode" class="tjm">
						<el-input v-model="registerForm.referralCode" placeholder="请输入推荐码" size="mini"
							class="custom-input" />
					</el-form-item>

					<el-form-item>
						<div>
							<el-checkbox v-model="checked">我已阅读</el-checkbox><span class="a"
								@click="ontext">《直达运动平台服务协议及隐私政策》</span>
						</div>
						<el-button type="primary" size="small" class="register-btn" :loading="loading"
							@click="handleRegister">
							{{ loading ? '注册中...' : '注册' }}
						</el-button>
					</el-form-item>
				</el-form>
				<div class="yyzh">
					<span class="a" @click="$router.push('/login')">已有账号,去登录</span>
				</div>
			</div>
		</div>

		<el-dialog title="验证码" :visible.sync="yzmshow" width="440px">
			<el-form :model="yzmform" ref="yzmform" :rules="yzmRules">
				<el-form-item class="yzmitem" prop="yzm">
					<el-input v-model="yzmform.yzm" placeholder="请输入验证码" class="yzminput"></el-input>
					<img :src="imgsrc" class="imgsrc" @click="generateRandomLetters()">
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="onyzmgb()" size="small">取消</el-button>
				<el-button type="primary" @click="onyzmsub()" size="small">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="" :visible.sync="textshow" width="900px">
			<rtext></rtext>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Register',
		data() {
			var validateConfirmPassword = (rule, value, callback) => {
				if (value == '') {
					callback(new Error('请再次输入密码'))
				} else if (value != this.registerForm.password) {
					callback(new Error('两次输入密码不一致'))
				} else {
					callback()
				}
			}

			var validatePhone = (rule, value, callback) => {
				const phoneReg = /^1[3-9]\d{9}$/
				if (value == '') {
					callback(new Error('请输入手机号'))
				} else if (!phoneReg.test(value)) {
					callback(new Error('请输入正确的手机号'))
				} else {
					callback()
				}
			}

			return {
				yzmshow: false,
				randomLetters: "",
				imgsrc: "",
				yzmform: {
					yzm: "",
				},

				yzmRules: {
					yzm: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},

				registerForm: {
					username: '',
					password: '',
					confirmPassword: '',
					realName: '',
					contact: '',
					phone: '',
					verifyCode: '',
					referralCode: '',
					email: ''
				},

				registerRules: {
					username: [{
							required: true,
							message: '请输入登录名',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 20,
							message: '登录名长度在 3 到 20 个字符',
							trigger: 'blur'
						}
					],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							min: 6,
							max: 20,
							message: '密码长度在 6 到 20 个字符',
							trigger: 'blur'
						}
					],
					confirmPassword: [{
						required: true,
						validator: validateConfirmPassword,
						trigger: 'blur'
					}],
					realName: [{
							required: true,
							message: '请输入真实姓名',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 10,
							message: '姓名长度在 2 到 10 个字符',
							trigger: 'blur'
						}
					],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					verifyCode: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							len: 4,
							message: '验证码为4位数字',
							trigger: 'blur'
						}
					],
					referralCode: [{
						required: false,
						message: '请输入推荐码',
						trigger: 'blur'
					}],

					email: [{
							required: true,
							message: '请输入邮箱地址',
							trigger: 'blur'
						},
						{
							type: 'email',
							message: '请输入正确的邮箱地址',
							trigger: 'blur'
						}
					]
				},

				verifyCodeDisabled: false,
				verifyCodeText: '获取验证码',
				loading: false,

				checked: false,
				textshow: false
			}
		},

		mounted() {
			// console.log();
			document.title = "会员注册";
		},

		inject: ['appdata'],

		methods: {
			handleGetVerifyCode() {
				if (this.verifyCodeDisabled) {
					return;
				}

				if (!this.registerForm.phone) {
					this.$message.warning('请先输入手机号');
					return
				}

				// 验证手机号格式
				const phoneReg = /^1[3-9]\d{9}$/
				if (!phoneReg.test(this.registerForm.phone)) {
					this.$message.warning('请输入正确的手机号')
					return
				}
				this.generateRandomLetters();
				this.yzmshow = true;
			},

			generateRandomLetters() {
				let result = '';
				for (let i = 0; i < 4; i++) {
					const randomCharCode = Math.floor(Math.random() * 26) + 65; // 生成65到90之间的随机数，对应大写字母A-Z
					result += String.fromCharCode(randomCharCode);
				}
				this.randomLetters = result + new Date().getTime();
				this.imgsrc = "http://api.zhidayd.com/adapipublic/captcha?uniq=" + this.randomLetters;
			},

			onyzmsub() {
				this.$refs['yzmform'].validate((valid) => {
					if (valid) {
						var params = {
							mobile: this.registerForm.phone,
							uniq: this.randomLetters,
							captcha: this.yzmform.yzm
						};
						this.$axios.post('api/sms/send', params).then(res => {
							if (res.data.code == 0) {
								this.$message.success('验证码已发送');
								this.verifyCodeDisabled = true;
								this.countdown = 60;
								this.onyzmgb();
								const timer = setInterval(() => {
									this.countdown--
									this.verifyCodeText = `${this.countdown}秒后重试`
									if (this.countdown <= 0) {
										clearInterval(timer)
										this.verifyCodeDisabled = false
										this.verifyCodeText = '获取验证码'
									}
								}, 1000);
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					}
				})
			},

			onyzmgb() {
				this.yzmform.yzm = "";
				this.yzmshow = false;
			},

			handleRegister() {
				this.$refs['registerFormRef'].validate((valid) => {
					if (valid) {
						if (!this.checked) {
							this.$message.warning('请阅读并勾选《直达运动平台服务协议及隐私政策》后注册');
							return
						}
						this.$axios.post('api/user/register', this.registerForm).then(res => {
							if (res.data.code == 0) {
								this.$message.success('注册成功');
								this.$router.push('/login');
							} else {
								this.$message.error(res.data.message);
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},

			ontext() {
				this.textshow = true;
				this.checked = true;
			}
		}
	}
</script>

<style scoped lang="less">
	.rbox {
		width: 100%;
		height: calc(100vh);
		display: flex;
	}

	.leftdiv {
		width: 100%;
		height: 100%;

		.img {
			width: 100%;
			height: 100%;
		}
	}

	.rightdiv {
		width: 550px;
		min-width: 550px;
		height: 100%;
		box-sizing: border-box;
		overflow-y: auto;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		.formdiv {
			width: 100%;
			min-height: 600px;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
		}

	}

	.register-btn {
		background-color: #F65730;
		color: #fff;
		width: 100%;
		text-align: center;
		border: 0;
		font-size: 14px;
		border-radius: 10px;
		display: block;
		cursor: pointer;
		height: 38px;
	}

	.note {
		line-height: 2;

		.note-text {
			font-size: 12px;
			color: #ef4444;
		}
	}

	.verify-btn {
		position: absolute;
		right: 14px;
		font-size: 14px;
		color: #2D93FF;
		cursor: pointer;
	}

	/deep/ .qq {
		margin-bottom: 1px !important;
	}

	/deep/ .el-form-item {
		margin-bottom: 14px;
	}

	.tjm {
		margin-bottom: 0;
	}

	.yzmitem {
		position: relative;
	}

	.imgsrc {
		width: 120px;
		height: 36px;
		cursor: pointer;
		position: absolute;
		right: 2px;
		top: 2px;
	}

	/deep/ .phone-input {
		.el-input__inner {
			padding-right: 100px !important;
		}
	}

	/deep/ .yzminput {
		.el-input__inner {
			padding-right: 140px !important;
		}
	}

	.yyzh {
		width: 550px;
		display: flex;
		justify-content: center;

		.a {
			color: #2D93FF;
			font-size: 16px;
			cursor: pointer;
		}
	}

	.a {
		color: #F65730;
		cursor: pointer;
	}

	// /deep/ .yzminput {
	// 	width: 150px;
	// }
	
	/deep/ .el-form-item__error {
		padding-top: 0 !important;
	}
	
	// /deep/ .el-form-item__content {
	// 	line-height: 32px;
	// }
	
	.tabs {
		width: 323px;
		display: flex;
		align-items: center;
		margin-bottom: 20px;
	
		div {
			color: #666;
			font-size: 20px;
			cursor: pointer;
			margin-right: 40px;
		}
	
		div:last-child {
			margin-right: 0;
		}
	
		.checked {
			font-size: 26px;
			color: #333;
			position: relative;
			font-weight: 600;
		}
	
		.checked::after {
			content: '';
			width: 100%;
			height: 3px;
			background: #F65730;
			position: absolute;
			left: 0;
			bottom: -10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/register.vue